
<template>
  <div>
    <template v-if="event_id">
      <div v-if="kind == 'icon'">
        <v-btn icon small color="error" @click="submitDelete()"><v-icon small>mdi-delete</v-icon></v-btn>
      </div>

      <div v-if="kind == 'button'">
        <v-btn color="error" small @click="submitDelete()"><v-icon left>mdi-delete</v-icon>Deletar</v-btn>
      </div>

      <div v-if="kind == 'fab'">
        <v-btn fab color="error" x-small @click="submitDelete()"><v-icon>mdi-delete</v-icon></v-btn>
      </div>

      <dialog-loading v-if="loading" ></dialog-loading>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: 'DeleteEvent',
  props: {
    direction_after_delete: {
      type: Number,
      default: 0
    },
    event_id: {
      type: [String, Number],
    },
    kind: {
      type: String,
      default: 'icon', // button, icon, fab
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    submitDelete() {
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: `Deseja excluir esse registro?`,
        text: 'Atenção: Essa ação é irreversível!',
        icon: 'question',
      }).then(r=>{
        if (r.isConfirmed) {
          this.deleteEvent()
        }
      });
    },
    deleteEvent(){
      this.loading = true
      Api.Event.delete(this.event_id).then((r)=>{
        this.$router.go(this.direction_after_delete)
      }).catch((err)=>{
        console.log(err)
      }).finally(()=>{
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>